var t = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "g", attrs: { "fill-rule": "nonzero" }, children: [{ tag: "path", attrs: { d: "M0 0h100v100H0z" } }, { tag: "path", attrs: { d: "M12.5 50H50v37.5H12.5z", fill: "#FFF" } }] }] }, name: "title", theme: "twotone" };
export {
  t as default
};
